// extracted by mini-css-extract-plugin
export default {"button":"Button_button__a26cx","close":"Button_close__6oWsf","africa":"Button_africa__I4ry7"};